import React, { useEffect, useState } from "react";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import {
    Button,
    Checkbox,
    FormControlLabel,
    FormGroup,
} from "@material-ui/core";
import { useTranslation } from "react-i18next";
import {
    useStylesUp, useStylesHed, useStylesAuto, useStylesTF, useStylesTD, useStylesBA, useStylesLbl
    , useStylesUiElemment,
    useStylesSpDial
} from '../../../St/Reports/UseStyle';
export default function PumsForm(props) {
    const {
        AutoOptions,
        rptParams,
        rptParamsAuto,
        onChangeAutoData,
        changTField,
        optionsItems
    } = props;

    const { t } = useTranslation(["forms"]);
    const clasAo = useStylesAuto();

    const clasup = useStylesUp();
    const clashd = useStylesHed();
    const clasBA = useStylesBA();
    const clasTF = useStylesTF();
    const clasTD = useStylesTD();
    const claslbl = useStylesLbl();
    const clasui = useStylesUiElemment();
    const clasSp = useStylesSpDial();
    return (
        <React.Fragment>
            <Grid container style={{ padding: 5 }} spacing={1}>
                <Grid item lg={4} md={4} sm={4} xs={3} style={{marginBottom:"0.5rem"}}>
                    <TextField
                        fullWidth
                        variant="outlined"
                        size="small"
                        id="id"

                        label={t("pump-no")}
                        //className={clasTF.clrBlack}
                        InputLabelProps={{ className: claslbl.clrBlackLblS }}
                        InputProps={{ className: claslbl.clrBlackTxt, readOnly: true }}
                        // InputProps={{ className: clasTD.input, readOnly: true }}
                        type="text"
                        name="id"
                        value={rptParams.id}
                    />
                </Grid>
                <Grid item lg={8} md={8} sm={8} xs={9} style={{marginBottom:"0.5rem"}}>
                    <TextField
                        fullWidth
                        variant="outlined"
                        size="small"
                        id="barcode"
                        label={t("pump-name")}
                        type="text"
                        name="name"
                        value={rptParams.name}
                        InputLabelProps={{
                            className: claslbl.clrBlackLblS,

                        }}
                        InputProps={{ className: claslbl.clrBlackTxt }}
                        onChange={changTField("name")}
                    />
                </Grid>
                <Grid item lg={6} md={6} sm={6} xs={6} style={{marginBottom:"0.5rem"}}>
                    <TextField
                        fullWidth
                        variant="outlined"
                        size="small"
                        id="barcode"
                        label={t("pump-counter")}
                        type="number"
                        name="name"
                        value={rptParams.count}
                        InputLabelProps={{
                            className: claslbl.clrBlackLblS,

                        }}
                        InputProps={{ className: claslbl.clrBlackTxt }}
                        onChange={changTField("count")}
                    />
                </Grid>
                <Grid item lg={6} md={6} sm={6} xs={6} style={{ marginBottom: "0.5rem" }}>
                    <Autocomplete classes={clasAo}
                        value={rptParamsAuto?.item}
                        onChange={(event, newValue) => {
                            //   setBranch(newValue);
                            onChangeAutoData("item", newValue);

                        }}
                        id="combo-box-demo"
                        size="small"
                        options={AutoOptions.items}
                        getOptionLabel={(option) =>
                            typeof option === "string" ? option : option.name
                        }
                        style={{}}
                        disableClearable
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                InputLabelProps={{ shrink: true, className: claslbl.clrSale }}
                                label={t("item")}
                                variant="outlined"
                            />
                        )}
                    />
                </Grid>

                <Grid item lg={6} md={6} sm={6} xs={6} style={{ marginBottom: "0.5rem" }}>

                    <Autocomplete classes={clasAo}
                        value={rptParamsAuto.safe}
                        labelPlacement=""
                        onChange={(event, newValue) => { onChangeAutoData('safe', newValue) }}
                        id="controllable-states-demo" size="small"
                        options={AutoOptions.Safes}
                        getOptionLabel={(option) => (typeof option === 'string' ? option : option.name)}
                        disableClearable
                        renderInput={(params) =>
                            <TextField {...params} label={t("safe")} variant="outlined" size="small"
                                InputLabelProps={{ className: claslbl.clrSale }} />}
                    />
                </Grid>


                <Grid item lg={6} md={6} sm={6} xs={6} style={{ marginBottom: "0.5rem" }}>
                    <Autocomplete classes={clasAo}
                        value={rptParamsAuto.branch}
                        onChange={(event, newValue) => {
                            //   setBranch(newValue);
                            onChangeAutoData("branch", newValue);

                        }}
                        id="combo-box-demo"
                        size="small"
                        options={AutoOptions?.Branches}
                        getOptionLabel={(option) =>
                            typeof option === "string" ? option : option.name
                        }
                        style={{}}
                        disableClearable
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                InputLabelProps={{ shrink: true, className: claslbl.clrSale }}
                                label={t("branch")}
                                variant="outlined"
                            />
                        )}
                    />
                </Grid>


            </Grid>
        </React.Fragment>
    );
}
